export default __webpack_public_path__ + "static/media/mark-attendance-disabled.a47add1f.svg";